import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button, Input, Anchor, message, Popover, Collapse, Carousel, Dropdown, Statistic, Modal } from "antd";
import { DotLoader } from 'react-spinners';
import CountUp from 'react-countup';
import {
  RightOutlined,
  PlusOutlined
} from "@ant-design/icons";
import "animate.css";
import WOW from "wow.js";
import suo from "@/assets/images/suocang.png";
import icon7 from "@/assets/images/icon7.png";
import jiantou3 from "@/assets/images/jiantou3.png";
import btn1 from "@/assets/images/btn1.png";
import btn2 from "@/assets/images/btn2.png";

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useAppKitAccount, useAppKit, useAppKitNetwork, useWalletInfo } from "@reown/appkit/react";
import { base } from '@reown/appkit/networks'
import { tokenAbi, LOCKLPABI, LOCKDEAIABI } from "@/web3/ido.js";
import { useAccount, useSignMessage, useDisconnect, useReadContract, useBalance, useWriteContract, useWaitForTransactionReceipt, useSwitchChain, useBlockNumber, useSendTransaction, useGasPrice } from 'wagmi'
import { parseEther, parseUnits, parseGwei, formatEther } from 'viem';
import { useQueryClient } from '@tanstack/react-query'
const { Link } = Anchor;
const Index = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const LOCKED_LP_CONTRACT_ADDRESS = import.meta.env.VITE_LOCKED_CONTRACT_ADDRESS;
  const LP_CONTRACT_ADDRESS = import.meta.env.VITE_LP_CONTRACT_ADDRESS;
  const DEAI_CONTRACT_ADDRESS = import.meta.env.VITE_NEW_DEAI_CONTRACT_ADDRESS;
  const LOCKED_DEAI_CONTRACT_ADDRESS = import.meta.env.VITE_LOCKED_NEW_DEAI_CONTRACT_ADDRESS;
  const chainIdOwn = Number(import.meta.env.VITE_CHAIN_ID)
  const { open, close } = useAppKit()
  const { caipNetwork, caipNetworkId, chainId, switchNetwork } = useAppKitNetwork()
  const { address, isConnected, caipAddress, status } = useAppKitAccount()
  const queryClient = useQueryClient()
  const { data: blockNumber } = useBlockNumber({ watch: true })
  const { writeContract, error, data: writeData, success } = useWriteContract();
  const { writeContract: writeContractLock, error: errorLock, data: writeDataLock } = useWriteContract();
  const isApprovedString = useRef(0);

  const result = useWaitForTransactionReceipt({
    hash: writeData,
    chainId: chainIdOwn,
    confirmations: 1,
  })
  const resultLock = useWaitForTransactionReceipt({
    hash: writeDataLock,
    chainId: chainIdOwn,
    confirmations: 1,
  })
  const [LockLpData, setLockLpData] = useState({})
  const [days, setDay] = useState("")
  const [lockNumber, setLockNumber] = useState("")
  const [loading, setLoading] = useState(false)
  const [lockDeaiIndex, setLockDeaiIndex] = useState(0)
  //余额 
  const { data: balanceLP, queryKey: queryKey1 } = useBalance({
    address: address,
    chainId: chainIdOwn,
    token: LP_CONTRACT_ADDRESS,
  });
  const { data: balanceDeai, queryKey: queryKey3 } = useBalance({
    address: address,
    chainId: chainIdOwn,
    token: DEAI_CONTRACT_ADDRESS,
  });
  const { data: lockConfigs, queryKey: queryKey4 } = useReadContract({
    address: LOCKED_LP_CONTRACT_ADDRESS,
    abi: LOCKLPABI,
    functionName: 'lockConfigs',
    chainId: chainIdOwn,
  })
  const { data: lockDeaiConfigs, queryKey: queryKey5 } = useReadContract({
    address: LOCKED_DEAI_CONTRACT_ADDRESS,
    abi: LOCKDEAIABI,
    functionName: 'lockConfigs',
    chainId: chainIdOwn,
  })
  const { data: isApprovedLp, queryKey: queryKey } = useReadContract({
    address: LP_CONTRACT_ADDRESS,
    abi: tokenAbi,
    functionName: 'allowance',
    chainId: chainIdOwn,
    args: [address, LOCKED_LP_CONTRACT_ADDRESS]
  })
  const { data: isApprovedDeai, queryKey: queryKey2 } = useReadContract({
    address: DEAI_CONTRACT_ADDRESS,
    abi: tokenAbi,
    functionName: 'allowance',
    chainId: chainIdOwn,
    args: [address, LOCKED_DEAI_CONTRACT_ADDRESS]
  })
  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: queryKey1 })
    queryClient.invalidateQueries({ queryKey: queryKey })
    queryClient.invalidateQueries({ queryKey: queryKey2 })
    queryClient.invalidateQueries({ queryKey: queryKey3 })
    queryClient.invalidateQueries({ queryKey: queryKey4 })
    queryClient.invalidateQueries({ queryKey: queryKey5 })
  }, [blockNumber, queryClient])
  useEffect(() => {
    console.log("balanceLP", balanceLP)
    console.log("lockConfigs", lockConfigs)
    console.log("lockDeaiConfigs", lockDeaiConfigs)
  }, [balanceLP, lockConfigs, lockDeaiConfigs])
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (error) {
        setLoading(false)
        let str = JSON.parse(JSON.stringify(error).replace(/\n/g, ""));
        message.warning(str.shortMessage);

      }

    }, 300);
    return () => clearTimeout(timeout);
  }, [error]);
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (errorLock) {
        console.log("errorLock", errorLock)
        setLoading(false)
        let str = JSON.parse(JSON.stringify(errorLock).replace(/\n/g, ""));
        message.warning(str.shortMessage);

      }

    }, 300);
    return () => clearTimeout(timeout);
  }, [errorLock]);
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (result?.status === "success") {
        if (isApprovedString.current === 1) {
          isApprovedString.current = 0
          if (tabIndex === 1) {
            sendTransactionLp()
          }
          if (tabIndex === 2) {
            sendTransactionDeai()
          }
        }

      }
      if (result?.status === "error") {
        message.error(t("error"));
        setLoading(false)

      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [result]);
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (resultLock?.status === "success") {
        message.success(t("Success"))
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
      if (resultLock?.status === "error") {
        message.error(t("error"));
        setLoading(false)

      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [resultLock]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (chainId) {
        if (chainId != Number(chainIdOwn)) {
          switchNetwork(base)
        }
      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [chainId]);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    window.sessionStorage.setItem("lang", lang)
    setLangType(lang)
  }
  const goComingSoon = () => {
    message.warn("Coming Soon")
  }
  const goOpen = (url) => {
    window.open(url)
  }
  const saveNumberTwo = (num) => {
    if (num * 1 === 0) return 0;
    let arr = (num + "").split(".");
    if (arr.length === 2) {
      let new_num = arr[0] + "." + arr[1].substring(0, 2);
      return new_num === "0.00" ? "0" : new_num;
    } else {
      return num + ".00";
    }
  }
  const onChange = ({ target: { value } }) => {
    setDay(parseInt(value) > 0 ? parseInt(value) : "")
  }
  const onChange1 = ({ target: { value } }) => {
    setLockNumber(value)
  }
  const tapLock = (index, day) => {
    if (index === 4 && day <= 180) {
      return message.warn(t("More than 180 days but less than 10000 days"))
    }
    if (index === 4 && day > 10000) {
      return message.warn(t("More than 180 days but less than 10000 days"))
    }
    setTabIndex(1)
    setLockLpData({
      index: index,
      day: day
    })
    setIsModalOpen(true)
  }
  const tapLockSure = () => {
    if (Number(lockNumber) > 0) {
      if (tabIndex === 1) {
        if (Number(balanceLP.formatted) < Number(lockNumber)) {
          return message.warn(t("Insufficient Balance"))
        }
      }
      if (tabIndex === 2) {
        if (Number(balanceDeai.formatted) < Number(lockNumber)) {
          return message.warn(t("Insufficient Balance"))
        }
      }
      setLoading(true)
      if (tabIndex === 1) {
        if (Number(isApprovedLp) < parseEther(lockNumber)) {
          // 授权
          isApprovedString.current = 1;
          writeContract({
            address: LP_CONTRACT_ADDRESS,
            abi: tokenAbi,
            functionName: "approve",
            chainId: chainIdOwn,
            args: [LOCKED_LP_CONTRACT_ADDRESS, "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"]
          })
        } else {
          sendTransactionLp()
        }
      }
      if (tabIndex === 2) {
        if (Number(isApprovedDeai) < parseEther(lockNumber)) {
          // 授权
          isApprovedString.current = 1;
          writeContract({
            address: DEAI_CONTRACT_ADDRESS,
            abi: tokenAbi,
            functionName: "approve",
            chainId: chainIdOwn,
            args: [LOCKED_DEAI_CONTRACT_ADDRESS, "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"]
          })
        } else {
          sendTransactionDeai()
        }
      }
    } else {
      return message.warn(t("The number of locked warehouses cannot be less than 0"))
    }
  }
  const sendTransactionLp = () => {
    writeContractLock({
      address: LOCKED_LP_CONTRACT_ADDRESS,
      abi: LOCKLPABI,
      functionName: "userLock",
      chainId: chainIdOwn,
      args: [LockLpData.index, LockLpData.day, parseEther(lockNumber)]
    })
  }
  const sendTransactionDeai = () => {
    console.log("lockDeaiIndex,parseEther(lockNumber)", lockDeaiIndex, parseEther(lockNumber))
    writeContractLock({
      address: LOCKED_DEAI_CONTRACT_ADDRESS,
      abi: LOCKDEAIABI,
      functionName: "userLockDeai",
      chainId: chainIdOwn,
      args: [lockDeaiIndex, parseEther(lockNumber)]
    })
  }
  const tapLockDeai = (index) => {
    setTabIndex(2)
    setLockDeaiIndex(index)
    setIsModalOpen(true)
  }
  const tapHistory = (num) => {
    if (num === 1) {
      navigate("/historylp")
    }
    if (num === 2) {
      navigate("/historydeai")
    }
  }
  return (
    <div className="home_box">
      <div className="tab_box">
        <div className="menu menu1 active">{t("Locking")}</div>
        <div className="menu" onClick={() => navigate("/mine")}>{t("mine")}</div>
      </div>
      <div className="con_box">
        <div className="top_flex">
          <div className="flex_box2">
            <div className="flex_box3">
              <div className="title">{t("Locking")}</div>
              <img className="suo" src={suo} alt="" />
            </div>
            <div className="message">{t("Lock your LP & Deai to earn income")}</div>
          </div>
          <div className="flex_box4">
            <div className="flex_1">
              <div>{t("Locked DEAI")}</div>
              <div className="balance">{t("Available DEAI")}：{saveNumberTwo(balanceDeai?.formatted || 0)}</div>
            </div>
            <div className="flex_box1">
              {
               lockDeaiConfigs &&  lockDeaiConfigs.map(item => {
                  return (
                    <div className="item" key={item.index}>
                      <div className="tit">{Number(item.time) / 24 / 60 / 60} {t("day")}</div>
                      <div className="box"><div className="num">{Number(item.multiple) / 10000}</div>{t("Daily income")}</div>
                      <div className="flex_item">
                        <div>{t("Locked")}</div>
                        <div>{formatEther(item.total)}</div>
                      </div>
                      <div className="flex_item">
                        <div>{t("Lock-up limit")}</div>
                        <div>{formatEther(item.limit)}</div>
                      </div>
                      <Button className="btn" type="primary" onClick={() => tapLockDeai(Number(item.index))}>{t("Locking")}</Button>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className="box3">
          <div className="flex_1">
            <div>{t("Locked LP")}</div>
            <div className="balance">{t("Available LP")}：{saveNumberTwo(balanceLP?.formatted || 0)}</div>
          </div>
          <div className="flex_box">
            <div className="item">
              <div className="tit">60 {t("day")}</div>
              <div className="box"><div className="num">1.5</div>{t("coefficient")}</div>
              <Button className="btn" type="primary" onClick={() => tapLock(1, 60)}>{t("Locking")}</Button>
            </div>
            <div className="item">
              <div className="tit">90 {t("day")}</div>
              <div className="box"><div className="num">1.8</div>{t("coefficient")}</div>
              <Button className="btn" type="primary" onClick={() => tapLock(2, 90)}>{t("Locking")}</Button>
            </div>
            <div className="item">
              <div className="tit">180 {t("day")}</div>
              <div className="box"><div className="num">2.0</div>{t("coefficient")}</div>
              <Button className="btn" type="primary" onClick={() => tapLock(3, 180)}>{t("Locking")}</Button>
            </div>
            <div className="item">
              <div className="tit1"><Input className="input" value={days} onChange={onChange} placeholder={t("More than 180 days, please enter")} /></div>
              <div className="box"><div className="num">2.0</div>{t("coefficient")}</div>
              <Button className="btn" type="primary" onClick={() => tapLock(4, days)}>{t("Locking")}</Button>
            </div>
          </div>
        </div>
        <div className="flex6">

          <div className="btn_box">
            <Button className="btn btn1" type="primary" onClick={()=>tapHistory(1)}>LP {t("Locking Records")}</Button>
            <Button className="btn btn2" type="primary" onClick={()=>tapHistory(2)}>DEAI {t("Locking Records")}</Button>
          </div>
          <div className="img_box">
            <img className="jiantou3" src={jiantou3} alt="" />
            <img className="icon7" src={icon7} alt="" />
          </div>
        </div>
      </div>
      <Modal title="" centered open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <div className="modal_box">
          <div className="flex">
            <div className="left_box">
              {
                tabIndex === 1 ? t("Locking LP") : t("Locking Deai")
              }
            </div>
            <div className="right_box">
              {
                tabIndex === 1 ? <div className="balance">{t("Available LP")}：{saveNumberTwo(balanceLP?.formatted || 0)}</div> : <div className="balance">{t("Available DEAI")}：{saveNumberTwo(balanceDeai?.formatted || 0)}</div>

              }
            </div>
          </div>
          <div className="input_box">
            <Input className="input" onChange={onChange1} value={lockNumber} placeholder={t("Please enter your lock amount")} />
          </div>
          <div className="btn_box">
            <Button type="primary" className="btn" loading={loading} onClick={tapLockSure}>{t("Locking")}</Button>
          </div>
        </div>
      </Modal>
    </div >
  );
};
export default Index;
